import { Filter } from './Filter';

export function TrainingYearFilter() {
  const yearOptions = [...Array(new Date().getFullYear() + 1 - 2012)]
    .map((_, i) => ({ value: `${2012 + i}`, label: (2012 + i).toString(), type: 'year' }))
    .reverse();

  return <Filter dataCy="training_year_filter" options={yearOptions} type="year" tag="AÑO" />;
}
